import React from "react";

function Card({
  name,
  caption,
  image,
  color,
  delay,
  icon,
  iconOffsetX,
  iconOffsetY,
  onClick,
}) {
  return (
    <div
      className="relative overflow-hidden rounded-lg aspect-video group cursor-pointer h-[18vh] sm:h-full w-full"
      onClick={onClick}
    >
      <div
        className="absolute inset-0 bg-cover bg-center opacity-50 transition-transform duration-300 group-hover:scale-110"
        style={{ backgroundImage: `url(${image})` }}
      ></div>
      <div
        className={`absolute inset-0 bg-gradient-to-r ${color} opacity-30 group-hover:opacity-50 transition-opacity duration-300 animate-pulse delay-${delay}`}
        style={{ animationDelay: `${delay}ms` }}
      ></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-white z-10">{name}</h2>
          <h2 className="text-[9px] font-bold text-white z-10">{caption}</h2>
        </div>
      </div>
      <div
        className={`absolute inset-0 ${iconOffsetX} ${iconOffsetY} flex items-center justify-center`}
      >
        <div className="text-[10rem] sm:text-[15rem] opacity-60 font-bold text-white z-10">
          {icon}
        </div>
      </div>
    </div>
  );
}

export default Card;
